import { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { updatePlayer } from '../api';

/**
 * ProfilePage
 *
 * @returns {JSX.Element}
 * @constructor
 */
const ProfilePage = () => {
  const player = JSON.parse(localStorage.getItem('player'));
  console.log(player);

  const [ name, setName ] = useState(player?.name ?? '');
  const [ changesMade, setChangesMade ] = useState(false);
  const [ errorMsg, setErrorMsg ] = useState('');
  const [ saving, setSaving ] = useState(false);

  /**
   * Initialize the form and auto save functionality.
   */
  useEffect(() => {
    if (player?.email) {
      const newName = document.querySelector('#displayName').value.trim(20);
      if (changesMade && newName.length > 0) {
        // Delay to wait for user to stop typing
        const timeOutId = setTimeout(() => {
          setSaving(true);
          // TODO: Validate?
          player.name = newName;
          updatePlayer(player).then((result) => {
            if (result.success === true) {
              setTimeout(() => {
                localStorage.setItem('player', JSON.stringify(player));
                setSaving(false);
              }, 1000);
            } else if (result.error) {
              setErrorMsg(result.error);
            } else {
              setErrorMsg('Unknown error saving profile. Please try again.');
            }
          });
        }, 500);

        return () => {
          clearTimeout(timeOutId);
        }
      }
    }
  }, [name]);

  /**
   * cleanDataClick
   *
   * Handler for the clean data button.
   *
   * @param data
   */
  const cleanDataClick = (data) => {
    if (!player?.email) {
      const answer = window.confirm('This option should only be used if you are experiencing issues. Are you sure you want to clean all data? This will delete all of your current games and is not recoverable.');
      if (answer === true) {
        for (const key in localStorage) {
          localStorage.removeItem(key);
        }
        window.location = '/';
      }
    } else {
      const answer = window.confirm('This option should only be used if you are experiencing issues. This will log you out abd delete all local data. You should still see your games when you log back in.')
      if (answer === true) {
        for (const key in localStorage) {
          localStorage.removeItem(key);
        }
      }
    }
  }

  /**
   * logOutClick
   *
   * Handler for the log out button.
   */
  const logOutClick = () => {
    localStorage.removeItem('player');
    window.location = '/';
  }

  /**
   * onInputChange
   *
   * Handler for the input change event.
   *
   * @param event
   */
  const onInputChange = (event) => {
    setChangesMade(true);
    setName(event.target.value)
  }

  const supportEmailLink = 'mailto:support@trivai.net?subject=id: ' + player._id ?? player.temp_id;
  const feedbackEmailLink = 'mailto:support@trivai.net?subject=id: ' + player._id ?? player.temp_id;

  return (
    <div className="page-wrap">
      <Header disableBackButton={saving}/>
      <div className="profile-page">
        {saving &&
          <div className="profile-saving-msg"><img className="saving-icon" src="/saving-white.svg" alt="saving"/></div>
        }
        {player?.email &&
          <div className="title">Profile</div>
        }
        <div className="error-msg">{errorMsg}</div>
        {player?.email &&
          <div>
            <div className="input-label-wrap">
              <div className="input-label">Display Name</div>
            </div>
            <input type="text" id="displayName" className="input" maxLength="20" defaultValue={name}
                   onChange={onInputChange}/>
          </div>
        }
        <a className="link-button profile-link" href={supportEmailLink}>Support</a>
        <a className="link-button profile-link" href={feedbackEmailLink}>Feedback</a>
        {player?.email &&
          <button className="link-button logout-link" onClick={logOutClick}>Log Out</button>
        }
        <button className="link-button logout-link" onClick={cleanDataClick}>Clean Data</button>
      </div>
      <Footer/>
    </div>
  )
}

export default ProfilePage;
